import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Fermer le menu quand on clique sur un lien
  const handleLink = () => setOpen(false);

  const links = [
    { label: 'Services', href: '#services' },
    { label: 'Réalisations', href: '#realisations' },
    { label: 'Certification RGE', href: '#rge' },
    { label: 'Planifier un appel', href: '#rdv' },
  ];

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}${open ? ' menu-open' : ''}`}>
      <div className="navbar-inner">
        <a href="#accueil" className="logo" onClick={handleLink}>
          <img src="/logo-tram.png" alt="Tram Energie Plomberie" style={{ height: 54 }} />
          <span className="logo-name">
            <span className="logo-tram">Tram</span><span className="logo-energie">energie</span>
          </span>
        </a>

        {/* Desktop */}
        <ul className="nav-links">
          {links.map(({ label, href }) => (
            <li key={href}><a href={href}>{label}</a></li>
          ))}
          <li><a href="#contact" className="nav-cta">Devis gratuit</a></li>
        </ul>

        {/* Bouton hamburger */}
        <button
          className={`nav-hamburger${open ? ' is-open' : ''}`}
          onClick={() => setOpen(o => !o)}
          aria-label="Menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Menu mobile */}
      <div className={`nav-mobile${open ? ' is-open' : ''}`}>
        <ul>
          {links.map(({ label, href }) => (
            <li key={href}>
              <a href={href} onClick={handleLink}>{label}</a>
            </li>
          ))}
          <li>
            <a href="#contact" className="nav-mobile-cta" onClick={handleLink}>
              Devis gratuit
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
